import React, { memo } from 'react';
import { Button } from 'react-bootstrap';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Cell, Row } from '../../../../../../components/Table/Grid';
import {
  checkedAdd,
  checkedAddShift,
  checkedDelete,
  checkedDeleteShift,
  modalOpen,
} from '../../../reducer';
import { getHighlightingText } from '../../../../../../utils/helper';
import * as modals from '../../../constants/modals';

const ServicesDeletedTableBodyRow = ({ id, index, search, searchType, name, mode, type, provider, provider_service_id, isChecked, rate, deleted_at, lastRow, dispatch, seeProviderColumn }) => {
  const isModeProvider = mode === 1;
  const onChecked = (e) => {
    const shift = !!e.nativeEvent.shiftKey;
    if (isChecked) {
      shift ? dispatch(checkedDeleteShift(id, index)) : dispatch(checkedDelete(id, index))
      return;
    }
    shift ? dispatch(checkedAddShift(id, index)) : dispatch(checkedAdd(id, index))
  }

  const onRestore = async () => {
    const name = modals.RESTORE;
    const data = {
      id,
    }
    dispatch(modalOpen(name, data))
  }

  return (
    <Row hover bg={isChecked}>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 42, width: 42 }}>
        <div className="d-flex justify-center">
          <input type="checkbox" onChange={onChecked} checked={isChecked} className="m-0 cursor-pinter" />
        </div>
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 50, width: 50 }}>
        <span dangerouslySetInnerHTML={getHighlightingText(id, search, (searchType === '1' || searchType === null))} />
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 325 }}>
        <span dangerouslySetInnerHTML={getHighlightingText(name, search, (searchType === '3' || searchType === null))} />
      </Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 190 }}>{type ? type.name : 'Default'}</Cell>
      {seeProviderColumn
        ? (
          <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 170 }}>
            {isModeProvider
              ? (
                <>
                  {provider
                    ? (
                      <div className="service-table__provider-name">
                        {provider.name}
                      </div>
                    ) : null}
                  {provider && provider_service_id
                    ? (
                      <div className="service-table__provider-service-id">
                        <span dangerouslySetInnerHTML={getHighlightingText(provider_service_id, search, (searchType === '2' || searchType === null))} />
                      </div>
                    ) : null}
                </>
              )
              : 'Manual'}
          </Cell>
        ) : null}
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 95 }}>{rate}</Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 154, width: 154 }}>{deleted_at}</Cell>
      <Cell borderBottom={lastRow ? 'none' : 'xs'} style={{ minWidth: 100, width: 154 }} paddingY="md" paddingX="md" alignHorizontal="right">
        <Button
          bsSize="xs"
          onClick={onRestore}
        >
          Restore
        </Button>
      </Cell>
    </Row>
  )
};

const arePropsEqual = (prevProps, nextProps) => isEqual(prevProps, nextProps);

ServicesDeletedTableBodyRow.propTypes = {
  id: PropTypes.number,
  index: PropTypes.number,
  search: PropTypes.string,
  searchType: PropTypes.string,
  name: PropTypes.string,
  mode: PropTypes.number,
  type: PropTypes.object,
  provider: PropTypes.object,
  provider_service_id: PropTypes.string,
  isChecked: PropTypes.bool,
  rate: PropTypes.string,
  deleted_at: PropTypes.string,
  lastRow: PropTypes.bool,
  dispatch: PropTypes.func,
  seeProviderColumn: PropTypes.bool,
}

export default memo(ServicesDeletedTableBodyRow, arePropsEqual);
